<form [formGroup]="leaseDetailService.entityPayment" (ngSubmit)="onSubmit()">
  <div class="payment-container">

    <!-- Header Principal -->
    <div class="payment-header">
      <div class="header-content">
        <div class="header-left">
          <i class="pi pi-credit-card"></i>
          <div class="header-text">
            <h1>Pago Inicial del Arrendamiento</h1>
            <p class="header-subtitle">Registra el comprobante del primer pago</p>
          </div>
        </div>
        <div class="header-right">
          <p-tag *ngIf="isPaymentRegistered()"
                 value="Pagado"
                 severity="success"
                 icon="pi pi-check-circle"></p-tag>
          <p-tag *ngIf="!isPaymentRegistered()"
                 value="Pendiente"
                 severity="warning"
                 icon="pi pi-clock"></p-tag>
        </div>
      </div>
    </div>

    <!-- Grid de Comprobante y Resumen -->
    <div class="voucher-grid">
      
      <!-- Card de Resumen (lado izquierdo) -->
      <div class="info-card summary-sticky">
        <div class="card-header">
          <i class="pi pi-calculator text-green-600"></i>
          <h3>Resumen del Pago</h3>
        </div>
        <div class="card-content">
          <div class="summary-amount-card">
            <div class="amount-label">Total a Pagar</div>
            <div class="amount-value">{{ leaseDetailService.getTermDataSafely()?.downPayment?.total | currency }}</div>
            
            <!-- Desglose compacto -->
            <div class="breakdown-compact-title">
              <i class="pi pi-list"></i>
              <span>Desglose del Pago:</span>
            </div>
            <ul class="breakdown-mini-list">
              <li>
                <span class="item-label"><i class="pi pi-dollar" style="color: #10B981;"></i> Anticipo</span>
                <span class="item-amount">{{ data?.quotation?.advance?.amount | currency }}</span>
              </li>
              <li>
                <span class="item-label"><i class="pi pi-percentage" style="color: #3B82F6;"></i> Comisión Apertura</span>
                <span class="item-amount">{{ data?.quotation?.openingCommission?.amount | currency }}</span>
              </li>
              <li>
                <span class="item-label"><i class="pi pi-file-edit" style="color: #8B5CF6;"></i> Ratificación</span>
                <span class="item-amount">{{ data?.quotation?.ratificationExpenses | currency }}</span>
              </li>
              <li *ngIf="leaseDetailService.getTermDataSafely()?.accessoriesDetail?.cash?.amount > 0">
                <span class="item-label"><i class="pi pi-shopping-cart" style="color: #F59E0B;"></i> Accesorios Contado</span>
                <span class="item-amount">{{ leaseDetailService.getTermDataSafely()?.accessoriesDetail?.cash?.amount | currency }}</span>
              </li>
              <li *ngIf="!leaseDetailService.getTermDataSafely()?.accessoriesDetail?.cash?.amount || leaseDetailService.getTermDataSafely()?.accessoriesDetail?.cash?.amount === 0" class="item-empty">
                <span class="item-label"><i class="pi pi-shopping-cart" style="color: #9CA3AF;"></i> Accesorios Contado</span>
                <span class="item-amount">$0.00</span>
              </li>
              <li *ngIf="leaseDetailService.getTermDataSafely()?.advancedRents?.number > 0">
                <span class="item-label"><i class="pi pi-calendar" style="color: #EF4444;"></i> Rentas Anticipadas</span>
                <span class="item-amount">{{ leaseDetailService.getTermDataSafely()?.advancedRents?.amount | currency }}</span>
              </li>
              <!-- F-016: solo existe en cotizaciones que cobran la renta anticipada completa -->
              <li *ngIf="leaseDetailService.getTermDataSafely()?.advancedRents?.accessories > 0">
                <span class="item-label"><i class="pi pi-calendar-plus" style="color: #EF4444;"></i> Accesorios de rentas anticipadas</span>
                <span class="item-amount">{{ leaseDetailService.getTermDataSafely()?.advancedRents?.accessories | currency }}</span>
              </li>
              <li *ngIf="!leaseDetailService.getTermDataSafely()?.advancedRents?.number || leaseDetailService.getTermDataSafely()?.advancedRents?.number === 0" class="item-empty">
                <span class="item-label"><i class="pi pi-calendar" style="color: #9CA3AF;"></i> Rentas Anticipadas</span>
                <span class="item-amount">$0.00</span>
              </li>
            </ul>

            <!-- Totales finales -->
            <div class="amount-breakdown">
              <div class="breakdown-item">
                <span class="breakdown-label">Subtotal:</span>
                <span class="breakdown-amount">{{ leaseDetailService.getTermDataSafely()?.downPayment?.amount | currency }}</span>
              </div>
              <div class="breakdown-item">
                <span class="breakdown-label">IVA (16%):</span>
                <span class="breakdown-amount">{{ leaseDetailService.getTermDataSafely()?.downPayment?.iva | currency }}</span>
              </div>
              <div class="breakdown-item total-item">
                <span class="breakdown-label">TOTAL:</span>
                <span class="breakdown-amount total-highlight">{{ leaseDetailService.getTermDataSafely()?.downPayment?.total | currency }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Formulario de Comprobante (lado derecho) -->
      <div class="info-card">
        <div class="card-header">
          <i class="pi pi-file-edit text-blue-600"></i>
          <h3>Datos del Comprobante</h3>
        </div>
        <div class="card-content">
          <div class="voucher-form">
            
            <!-- Forma de pago -->
            <div class="field field-flex">
              <label for="paymentWay">*Forma de pago:</label>
              <p-dropdown 
                formControlName="paymentWay" 
                [panelStyle]="{'width': '100%' }" 
                [style]="{'height': '45px'}" 
                scrollHeight="150px" 
                [options]="leaseDetailService.paymentWays" 
                optionLabel="label" 
                optionValue="value" 
                [filter]="true" 
                filterBy="label" 
                [showClear]="true" 
                placeholder="Selecciona una forma de pago"
                (onChange)="onPaymentWayChange()">
                <ng-template pTemplate="selectedItem">
                  <div class="flex align-items-center" *ngIf="e.value.paymentWay">
                    <div>{{leaseDetailService.getPaymentWayName(e.value.paymentWay)}}</div>
                  </div>
                </ng-template>
                <ng-template let-paymentWay pTemplate="item">
                  <div class="flex align-items-center">
                    <div>{{ paymentWay.label }}</div>
                  </div>
                </ng-template>
              </p-dropdown>
              <ng-container *ngIf="e.get('paymentWay')?.invalid && (e.get('paymentWay')?.dirty || e.get('paymentWay')?.touched)">
                <small class="p-error" *ngIf="e.get('paymentWay')?.errors?.['required']">La forma de pago es obligatoria.</small>
              </ng-container>
            </div>

            <!-- Fecha -->
            <div class="field field-flex">
              <label for="date">*Fecha:</label>
              <input 
                type="date" 
                pInputText 
                id="date" 
                formControlName="date" 
                required 
                (change)="onDateChange()" />
              <ng-container *ngIf="e.get('date')?.invalid && (e.get('date')?.dirty || e.get('date')?.touched)">
                <small class="p-error" *ngIf="e.get('date')?.errors?.['required']">La fecha de pago es obligatoria.</small>
              </ng-container>
            </div>

            <!-- Archivo -->
            <div class="field">
              <app-input-single-file 
                label="Comprobante de pago"
                (fileUrl)="onFileSelected($event)"
                (fileDeleted)="onFileDeleted()"
                (downloadRequested)="onDownloadRequested($event)"
                [tooltip]="'Comprobante del pago inicial del arrendamiento'"
                [documentName]="'initialPaymentVoucher'"
                [folder]="'initialPayment'"
                [id]="leaseDetailService.id"
                [fileUrlValue]="data?.initialPayment?.voucher">
              </app-input-single-file>
            </div>

          </div>
           <div class="payment-action">
            <button 
              pButton 
              pRipple 
              [label]="isPaymentRegistered() ? 'Pago Registrado Exitosamente' : 'Guardar Comprobante'"
              [icon]="isPaymentRegistered() ? 'pi pi-check-circle' : 'fa-solid fa-check'"
              [class]="isPaymentRegistered() ? 'p-button-outlined p-button-success p-button-lg' : 'p-button-success p-button-lg'"
              type="submit"
              [disabled]="isPaymentRegistered()"
              [loading]="leaseDetailService.loading"
              [style.width]="'100%'">
            </button>
          </div>
        </div>
      </div>

    </div>

  </div>
</form>

<!-- Toast para notificaciones -->
<p-toast position="top-right"></p-toast>
